<template>
  <v-container
    class="my-6"
  >
    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
      >
        <v-card>
          <v-card-title primary-title>
            <v-row
              class="text-center"
            >
              <v-col cols="12">
                <v-icon x-large class="blue--text text--darken-2">
                  mdi-shield-account
                </v-icon>
              </v-col>
              <v-col cols="12">
                <div
                  v-if="!newSuccessMessage"
                >
                  <p class="headline font-weight-black">
                    Hier kannst Du deinen Teamnamen ändern!
                  </p>
                  <p class="caption">
                    Dieser Name wird ggf. nach außen Sichtbar sein und für das Chat- / Nachrichtensystem verwendet.<br><small>(Das speichern könnte etwas länger dauern.)</small>
                  </p>
                </div>
                <div v-else>
                  <p class="title green--text">
                    Teamname erfolgreich geändert!
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col v-if="!newSuccessMessage">
                <v-text-field
                  v-model="teamname"
                  :rules="teamNameRules"
                  :error-messages="errorMessageTeamName"
                  prepend-icon="mdi-account"
                  type="text"
                  name="teamname"
                  label="Dein Teamname"
                  required
                />
                <my-alert
                  v-if="this.$store.state.error"
                  type="error"
                  :error="this.$store.state.error"
                  :title="this.$store.state.errorTitle"
                />
              </v-col>
              <v-col v-else>
                <p class="title green--text text-center">
                  Glückwunsch! Der Server hat Deinen neuen Teamnamen erfolgreich gespeichert.
                </p>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions
            v-show="!newSuccessMessage"
            class="text-center mb-6 pb-6"
          >
            <v-btn
              outlined
              large
              class="warning--text mx-auto"
              @click="cancelName()"
              :loading="this.$store.state.loading"
            >
              Abbrechen <v-icon right class="warning--text">
                mdi-cancel
              </v-icon>
            </v-btn>
            <v-btn
              outlined
              large
              class="primary--text mx-auto"
              @click="saveTeamName()"
              :loading="this.$store.state.loading"
            >
              speichern <v-icon right class="blue--text text--darken-2">
                mdi-send
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'Teamname',
  metaInfo: {
    title: 'Teamname ändern'
  },
  data () {
    return {
      teamname: '',
      tempTeamname: '',
      teamNameRules: [],
      errorMessageTeamName: [],
      newSuccessMessage: false
    }
  },
  watch: {
    teamname: function (value) {
      let name = value
      if (name === '' || typeof name === 'undefined') {
        name = ''
      } else {
        name = name.replace(/[^a-zA-Z0-9_\-öäüÖÄÜßẞ ]/g, '')
      }
      if (name.length > 32) {
        name = name.substring(0, 32)
      }
      this.$store.commit('teamStore/TEAM_SET_TEAM_NAME', name)
      this.teamname = name
    }
  },
  methods: {
    cancelName: function () {
      this.teamname = this.tempTeamname
      this.$store.commit('teamStore/TEAM_SET_TEAM_NAME', this.tempTeamname)
      this.$router.replace({ path: '/settings' })
    },
    saveTeamName: async function () {
      if (this.teamname.length === null || this.teamname.length < 3) {
        this.teamNameRules = ['Teamname muss mindestens 3 Zeichen haben']
        this.errorMessageTeamName = ['Teamname muss mindestens 3 Zeichen haben']
      } else {
        this.newSuccessMessage = await this.$store.dispatch('teamStore/saveTeamname', { teamname: this.teamname })
      }
    }
  },
  created () {
    // check if user is already logged in and then redirect to home
    if (this.$store.state.matchEvaluationInProgress) {
      this.$router.replace({ path: '/' })
    }
    this.teamname = this.$store.state.teamStore.team.name
    this.tempTeamname = this.$store.state.teamStore.team.name
  }
}
</script>
